import { ExclamationCircleOutlined } from '@severalnines/frontend_hub/libs/icons';
import React, { ReactElement } from 'react';

function CcxIconExclamationCircle(): ReactElement {
    return <ExclamationCircleOutlined />;
}

export default CcxIconExclamationCircle;
